import CIMSSelect from '../..'
import { CommonSelect } from '../types'
import { useLabTechSelectContext } from './LabTechSelectContext'

/**
 * a {@link CIMSSelect} for lab techs
 *
 * wrap components using this in the LabTechSelectProvider
 */
const LabTechSelect: React.FC<CommonSelect> = (props) => {
  const { loading, options } = useLabTechSelectContext()
  return <CIMSSelect loading={loading} options={options} {...props} />
}

export default LabTechSelect
